import styled from 'styled-components'

const UploadZone = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgb(241, 241, 241);
    text-align: center;
    border-radius: 4px;
    outline: 0;
    padding: 8px;
    font-size: 14px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    border: 2px dashed #37a3ef;
    transition: opacity 0.3s ease-in-out;
    &.active {
        opacity: 0.8;
        z-index: 10000;
        background-color: rgba(243, 249, 251);
        color: #37a3ef;
    }
    > span {
        font-size: 24px;
        margin-top: 32px;
    }
    > i {
        color: #37a3ef;
    }
`

const UploadsPreview = styled.div`
    display: flex;
    width: 600px;
    font-size: 12px;
    border-bottom: 1px solid #e1e1e1;
    padding: 8px 16px;

    > div {
        > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            width: 100%;
            padding: 4px 6px;
        }
    }
    > div{
        display: flex;
        align-items: center;
    }

    > div:nth-child(1) {
        width: 200px;
        display: flex;
        > div:first-child {
            margin: 1px 8px 0 0;
        }
    }
    > div:nth-child(2) {
        width: 150px;
    }
    > div:nth-child(3) {
        width: 150px;
    }
    > div:nth-child(4) {
        width: 90px;
    }
    > div:nth-child(5) {
        width: 68px;
        display: flex;
        justify-content: flex-end;
        > i {
            margin-top: 3px;
            cursor: pointer;
            z-index: 9999;
        }
        .fa-trash-alt {
            color: #c43535;
        }
        .fa-paint-brush {
            color: #37a3ef;
            margin-right: 8px;
        }
    }
    &.labels {
        > div {
            font-size: 9px;
            text-transform: uppercase;
        }
        border-bottom: 1px solid #d1d1d1;
        padding: 4px 16px;
    }
`
const Attachments = styled.div`
    display: flex;
    flex-direction: column;
    width: 600px;
`
const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 8px;
    min-height: 300px;
`
const Toolbar = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    > .btn {
        text-transform: uppercase;
        margin-right: 8px;
        z-index: 9999;
        > i {
            margin-right: 8px;
        }
    }
    > .disabled {
        text-transform: uppercase;
        margin-right: 8px;
        background-color: #94918a !important;
        border-color: #94918a !important;
    }
    > span {
        color: rgb(204, 0, 0);
        font-size: 13px;
    }
`
const ListContainer = styled.div`
    max-height: 204px;
    overflow-y: auto;
`
const Footnote = styled.span`
    position: absolute;
    bottom: 0;
    width: 600px;
    display: flex;
    justify-content: center;
    padding-bottom: 16px;
`

export { UploadZone, UploadsPreview, Attachments, Column, Toolbar, ListContainer, Footnote }
